import script from "./MemberCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./MemberCard.vue?vue&type=script&lang=ts&setup=true"

import "./MemberCard.vue?vue&type=style&index=0&id=55c59600&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55c59600"]])

export default __exports__